import PropTypes from 'prop-types';
import React from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';

import { buttonUIComponent } from 'ctm-css-themes';
import { getPathWithQueryString, shapedPropsWarning } from 'ctm-util-functions';

import { getContent } from '../utils';

import styles from './internal_link.css';

/**
 * Internal Link Component
 * @desc Allows a user to link to an internal location (eg progress bar). Things like pdfs should use the <Anchor /> component.
 * Kept this separate from the anchor component so that it follows the single responsibility principle.
 * @param {Object} props React props
 * @returns {Node} InternalLink - The internal Link component
 */
const InternalLink = (props) => {
    const { className, activeClassName = 'active', 'data-id': dataId, href, UIComponent, variant, onClick } = props;
    const classList = classNames(className, styles[`variant_${variant}`] || null, buttonUIComponent[UIComponent] || null);

    // @todo remove once all shapedProps are gone
    shapedPropsWarning(props, 'InternalLink');

    return (
        // there will be times where we want to intentionally stop the navigation
        // in the case of the user having saved results, we will display a modal onClick instead of page routing
        <NavLink to={href ==='javascript:void();' ? '#' : getPathWithQueryString(href)} onClick={onClick} id={dataId} data-id={dataId} activeClassName={activeClassName} className={classList} aria-current="true">
            {getContent(props)}
        </NavLink>
    );
};

InternalLink.propTypes = {
    /** Required: which route do you want the link to target? */
    href: PropTypes.string.isRequired,
    'data-id': PropTypes.string.isRequired,
    /** The text value that the link is going to wrap itself around */
    // eslint-disable-next-line react/no-unused-prop-types
    label: PropTypes.string,
    /** Required: This is the active class that is applied when a link is clicked on. */
    activeClassName: PropTypes.string,
    /** Optional: The base css styles you want to apply to the link  */
    className: PropTypes.string,
    UIComponent: PropTypes.string,
    variant: PropTypes.string,
    /** Optional: For any custom click functionality */
        onClick: PropTypes.func
};

export { InternalLink };
